import { fetchRate, TRateResponse } from '../../repositories/cian-chat-bot/v1/rate';
import { IApplicationContext } from '../../types/applicationContext';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents } from '../../types/telemetry';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

const DEFAULT_ERROR_MESSAGE = 'Ошибка при отправке рейтинга чатбота';

export async function fetchSetRating(
  { httpApi, logger, telemetry }: IApplicationContext,
  rating: number,
  comment?: string,
): Promise<boolean> {
  try {
    const { statusCode, response }: TRateResponse = await fetchRate({
      httpApi,
      parameters: {
        rating,
        comment,
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chatbot,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return true;
  } catch (error) {
    telemetry.increment(ETelemetryEvents.ChatbotSetRatingFail);

    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chatbot,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'cian-chat-bot',
      pathApi: '/v1/rate/',
      parameters: JSON.stringify({ rating, comment }),
    });

    return false;
  }
}
